import { render } from "./TutorialTooltip.vue?vue&type=template&id=12074c6d"
import script from "./TutorialTooltip.vue?vue&type=script&lang=js"
export * from "./TutorialTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__